import type { FaireProductEntity } from "../../entity_types/product";

export const p_48za2aajbb: FaireProductEntity = {
  token: "p_48za2aajbb",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Lazurite",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/b48c359482839642ce21cab000ef69f51b42dbf7902e173797144dc751aad491.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/343b5533d5e0ad444213646bc497bc902a1b5e2ff51e81fcb26c8e5168b64b4f.jpeg",
    "https://cdn.faire.com/fastly/32bafde4057ee1a37e18ec81ba1f0f92bae40602bbd6a73f2a1167c2cf879e78.jpeg",
    "https://cdn.faire.com/fastly/abcc95b383bc4457d9b5b242317e74973bd6480eb15ea879e90d9769a2f7cb21.jpeg",
    "https://cdn.faire.com/fastly/30d0842d4f6da4a918383bc45cbbfc4250cb0d47e32287e299c72951ac35a032.jpeg",
    "https://cdn.faire.com/fastly/ed0a6060b37ee5cef52be31c15ac88715a861703a6097bc3516dcd923d0b5eb6.jpeg",
    "https://cdn.faire.com/fastly/f21b7915ff311096d27765bf1ee9c6029974fd0551750d932bca453992274558.jpeg",
    "https://cdn.faire.com/fastly/790c2c459b5e97e7f867a24c4c76930f4df297cb6ad4878544b00250f562204b.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 100% cotton \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:26.876Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
